import { Button, Popconfirm } from "antd";
import dayjs from "dayjs";
export function getOutletExpenseTableHeader(handleAction) {
  return [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a.category.localeCompare(b.category),
    },
    {
      title: "Description",
      dataIndex: "e_desc",
      key: "e_desc",
      sorter: (a, b) => a.e_desc.localeCompare(b.e_desc),
    },
    {
      title: "Voucher",
      dataIndex: "voucher",
      key: "voucher",
    },
    {
      title: "Created By",
      dataIndex: "addedby",
      key: "addedby",
      sorter: (a, b) => a.addedby.localeCompare(b.addedby),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Returned Amount",
      dataIndex: "ret_amt",
      key: "ret_amt",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => {
        const isPreviousDate = dayjs(record.date).isBefore(dayjs(), 'day'); // Check if past date
        const isReturned = record.ret_amt > 0;


        return (
          <Popconfirm
            title={`Are you sure to update ${record.voucher}?`}
            onConfirm={() => handleAction(record.id)}
            disabled={isReturned} // ❌ Disable Popconfirm
          >
            <Button type="primary" disabled={isReturned}>
              Update
            </Button>
          </Popconfirm>
        );
      },

      // render: (text, record) => {
      //   const isPreviousDate = dayjs(record.date).isBefore(dayjs(), 'day'); // Check if past date
      //   const retAmt = record.ret_amt;

      //   return (
      //     <Popconfirm
      //       title={`Are you sure to update ${record.voucher}?`}
      //       onConfirm={() => handleAction(record.id)}
      //       disabled={isPreviousDate} // ❌ Disable Popconfirm
      //     >
      //       <Button type="primary" disabled={isPreviousDate}>
      //         Update
      //       </Button>
      //     </Popconfirm>
      //   );
      // },


      // render: (text, record) => (
      //   <>
      //     <Popconfirm
      //       title={`Are you sure to update ${record.voucher}?`}
      //       onConfirm={() => handleAction(record.id)}
      //     >
      //       <Button type="primary">Update</Button>
      //     </Popconfirm>
      //   </>
      // ),
    },
  ];
}

// render: (text, record) => (

//   <>
//     <Popconfirm
//       title={`Are you sure to update ${record.voucher}?`}
//       onConfirm={() => handleAction(record.id)}
//     >
//       <Button type="primary">Update</Button>
//     </Popconfirm>
//   </>
// ),
